export const aciSafeBox = {
    iconName: 'safe-box',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 16 18' },
        path: {
            attr: {
                d: 'M2.667 3.7v3.2m0 2.133v3.2m0 2.667v1.6m10.666-1.6v1.6m-3.2-5.867a2.133 2.133 0 110-4.266 2.133 2.133 0 010 4.266zM1.6 1.033h12.8c.589 0 1.066.478 1.066 1.067v11.733c0 .59-.477 1.067-1.066 1.067H1.6c-.59 0-1.067-.478-1.067-1.067V2.1c0-.59.478-1.067 1.067-1.067z',
                stroke: 'currentColor',
                'stroke-width': '1.067',
                'stroke-linecap': 'round',
            },
        },
    },
};
